var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "render-post", staticClass: "container-render-post" },
    [
      _c(
        "div",
        {
          staticClass: "render-reel-instagram",
          style: { fontSize: _vm.fontSize + "px" },
        },
        [
          _c("div", { staticClass: "header-app" }, [
            _vm._v("\n            Reels\n        "),
          ]),
          _c(
            "div",
            { staticClass: "reel-content", on: { click: _vm.clickOnPost } },
            [
              _vm._l(
                _vm.medias
                  .filter((m) => m.info.type.startsWith("video/"))
                  .slice(0, 1),
                function (media, index) {
                  return _vm.medias.length
                    ? _c("video", {
                        key: index,
                        ref: "video",
                        refInFor: true,
                        class: { cover: media.info.aspectRatio <= 0.5625 },
                        attrs: {
                          autoplay: true,
                          loop: "",
                          playsinline: "",
                          preload: "metadata",
                          src: media.url,
                          type: media.info.type,
                        },
                        domProps: { muted: _vm.muteSound || _vm.music },
                        on: { timeupdate: _vm.videoCheckLoop },
                      })
                    : _vm._e()
                }
              ),
              _vm.music
                ? _c("AudioPlayer", {
                    ref: "audio",
                    attrs: {
                      src: (_vm.music.track || _vm.music.original_sound)
                        .progressive_download_url,
                      start: parseInt((_vm.music.start || 0) / 1000),
                      duration: parseInt((_vm.music.duration || 0) / 1000),
                      loop: true,
                      volume:
                        !_vm.mutedSound && !_vm.modes.includes("addMusicMode")
                          ? 0.5
                          : 0,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "nav-lateral" }, [
                _c("div", { staticClass: "like" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "_8-yf5",
                      attrs: {
                        "data-v-cafbc80a": "",
                        "aria-label": "J’aime",
                        fill: "#FFF",
                        height: "auto",
                        viewBox: "0 0 48 48",
                        width: "auto",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "data-v-cafbc80a": "",
                          d: "M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "comment" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "_8-yf5",
                      attrs: {
                        "data-v-cafbc80a": "",
                        "aria-label": "Commenter",
                        fill: "#FFF",
                        height: "auto",
                        viewBox: "0 0 48 48",
                        width: "auto",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "data-v-cafbc80a": "",
                          "clip-rule": "evenodd",
                          d: "M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z",
                          "fill-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "send" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "_8-yf5",
                      attrs: {
                        "data-v-cafbc80a": "",
                        "aria-label": "Partager la publication",
                        fill: "#FFF",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 48 48",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "data-v-cafbc80a": "",
                          d: "M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._m(0),
              ]),
              _c("div", { staticClass: "info-reel" }, [
                _c("div", { staticClass: "page" }, [
                  _c(
                    "div",
                    {
                      staticClass: "images",
                      class: { multiple: _vm.pages.length > 1 },
                    },
                    [
                      _vm._l(_vm.pages.slice(0, 3), function (page, index) {
                        return _c("img", {
                          key: index,
                          attrs: { src: page.avatar },
                          on: {
                            click: () => {
                              page.iconEdited
                                ? _vm.$emit("clickPage", page.id)
                                : _vm.openInstagramPage(page.name)
                            },
                          },
                        })
                      }),
                      _vm.pages.length > 3
                        ? _c("div", { staticClass: "count" }, [
                            _vm._v(
                              "\n                            +" +
                                _vm._s(_vm.pages.length - 3) +
                                "\n                        "
                            ),
                          ])
                        : _vm._e(),
                      _vm.collaborators.length && _vm.pages.length == 1
                        ? [
                            _c("img", {
                              staticClass: "collaborator",
                              attrs: { src: _vm.collaborators[0].image },
                              on: {
                                click: () => {
                                  _vm.openInstagramPage(_vm.collaborators[0].id)
                                },
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "names" }, [
                    _vm.pages.length <= 1
                      ? _c(
                          "p",
                          { staticClass: "page-name" },
                          [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openInstagramPage(
                                      _vm.pages[0].name
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.pages[0].name))]
                            ),
                            _vm.collaborators.length
                              ? [
                                  _vm._v(
                                    "\n                                et\n                                "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.openInstagramPage(
                                            _vm.collaborators[0].id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.collaborators[0].name ||
                                            _vm.collaborators[0].id
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.musicName && _vm.pages.length <= 1
                      ? _c("p", { staticClass: "music-name" }, [
                          _c("i", { staticClass: "fa-solid fa-music" }),
                          _vm._v(_vm._s(_vm.musicName)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm.musicName && _vm.pages.length > 1
                  ? _c("p", { staticClass: "music-name" }, [
                      _c("i", { staticClass: "fa-solid fa-music" }),
                      _vm._v(_vm._s(_vm.musicName)),
                    ])
                  : _vm._e(),
                _vm.textTranslate
                  ? _c("div", {
                      staticClass: "description-reel",
                      class: { "cut-content": !_vm.fullContent },
                      domProps: { innerHTML: _vm._s(_vm.textTranslate) },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleFullContent.apply(null, arguments)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c("div", {
                key: _vm.muteSound ? "no-sound" : "sound",
                class: _vm.muteSound ? "no-sound" : "sound",
              }),
            ],
            2
          ),
        ]
      ),
      _vm.modes.includes("addIdentifierMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.personsIdentified,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addCollaboratorMode")
        ? _c("SelectPerson", {
            attrs: {
              personsSelect: _vm.collaborators,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
      _vm.modes.includes("addPlaceMode")
        ? _c("SelectPlace", {
            attrs: {
              placeSelected: _vm.place,
              position: _vm.positionFormOverlay,
              network: "instagram",
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
      _vm.modes.includes("addMusicMode")
        ? _c("SelectMusic", {
            attrs: {
              durationLock:
                _vm.medias.length && _vm.medias[0].info.type2 == "video"
                  ? parseInt(_vm.medias[0].info.duration) * 1000
                  : undefined,
              musicSelected: _vm.music,
              position: _vm.positionFormOverlay,
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
      _vm.modes.includes("addProductMode")
        ? _c("SelectProduct", {
            attrs: {
              productsSelect: _vm.products,
              positionClick: _vm.paramsContentOverflow.identify.positionClick,
              position: _vm.positionFormOverlay,
            },
            on: {
              close: _vm.closeContentOverflow,
              resetPositionClick: _vm.resetClick,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more" }, [
      _c("i", { staticClass: "fa-solid fa-ellipsis" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }